import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class InformateCheckGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (route.params.isRedirect == 'false' || route.params.isRedirect == 'true') {
            return true;
        } else {
            this.router.navigate(['/404']);
        }
        return true;
    }
}
